import React, { useEffect, useState } from "react";
import { BRAND_ASSETS } from "@/lib/brandAssets";

/**
 * First-load preloader: shows the horizontal logo on a clean white background
 * for ~700ms then fades out. Skips subsequent route transitions (gated via
 * sessionStorage). Token-cheap CSS-only animation.
 */
export default function Preloader() {
  const [done, setDone] = useState(() => {
    try { return sessionStorage.getItem("kb_preloaded") === "1"; } catch { return false; }
  });

  useEffect(() => {
    if (done) return;
    const t = setTimeout(() => {
      try { sessionStorage.setItem("kb_preloaded", "1"); } catch (_) { /* ignore */ }
      setDone(true);
    }, 900);
    return () => clearTimeout(t);
  }, [done]);

  if (done) return null;

  return (
    <div
      data-testid="kb-preloader"
      className="fixed inset-0 z-[100] flex items-center justify-center bg-white kb-preloader-fade"
    >
      <div className="flex flex-col items-center gap-6">
        <img
          src={BRAND_ASSETS.logoHorizontalDark}
          alt="KhojByte Research Lab"
          className="h-10 md:h-12 select-none kb-preloader-pulse"
          draggable="false"
        />
        <div className="w-40 h-[2px] bg-kb-divider rounded overflow-hidden">
          <div className="h-full w-1/3 bg-kb-purple kb-preloader-bar" />
        </div>
      </div>
    </div>
  );
}
